import React, {useState, useEffect} from 'react';
import {withTranslation} from 'react-i18next';
import {Form, Field} from 'react-final-form';
import {classNames} from 'primereact/utils';
import {Button} from 'primereact/button';
import {Panel} from "primereact/panel";
import {addLocale} from 'primereact/api';
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {Dropdown} from "primereact/dropdown";

import EmployeeListService from "../_services/employee/EmployeeListService";
import {InputMask} from "primereact/inputmask";
import moment from "moment";
import {Calendar} from "primereact/calendar";
import axios from "axios";
import {InputNumber} from "primereact/inputnumber";

const ScheduleFormComponent = (props) => {

  //form
  const [formData, setFormData] = useState({
    //timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    schedule_group: props.initialValues.id,
    break_minutes: 0,
  });
  const [loading, setLoading] = useState(false);
  const validate = (data) => {
    let errors = {};
    // if (!data.name) {
    //   errors.name = 'Az megnevezés nem lehet üres';
    // }
    return errors;
  };
  const onSubmit = (data, form) => {
    const basePayload = {
      ...data,
      ...formData
    };
    let _data = {}
    if(props?.initialValues?.type === 'EMPLOYEE_CAPACITY' ) {
      let employeeIds = []
      employeesToAdd.map(function (item, index) {
        employeeIds.push(item.id)
      })
      _data = {
        ...basePayload,
        employees: employeeIds
      }
    }
    else {
      _data = {
        ...basePayload
      }
    }
    setLoading(true)
    setFormData({
      ...formData,
      _data
    });
    axios.post(process.env.REACT_APP_API_HOST + "/api/v2/schedule/new/batch",
      _data,
      {
        params: {},
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
          'App-Network': localStorage.getItem("networkId")
        }
      })
      .then(response => {
        window.App.toastShow('success', 'Sikeres mentés!');
        window.App.setState({
          rerenderScheduleList: true,
          sidebarScheduleCreate: false
        })
        setLoading(false)
      })
      .catch(error => {
        window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
        setLoading(false)
      })
    form.restart();
  };
  const isFormFieldValid = (meta) => !!(meta.touched && meta.error);
  const getFormErrorMessage = (meta) => {
    return isFormFieldValid(meta) && <small className="p-error">{meta.error}</small>;
  };

  addLocale('hu', {
    firstDayOfWeek: 1,
    dayNames: ['vasárnap', 'hétfő', 'kedd', 'szerda', 'csütörtök', 'péntek', 'szombat'],
    dayNamesShort: ['vas', 'hé', 'ke', 'sze', 'csü', 'pé', 'szo'],
    dayNamesMin: ['V', 'H', 'K', 'SZ', 'CS', 'P', 'SZ'],
    monthNames: ['január', 'február', 'március', 'április', 'május', 'június', 'július', 'augusztus', 'szeptember',
      'október', 'november', 'december'],
    monthNamesShort: ['jan', 'feb', 'mar', 'ápr', 'máj', 'jun', 'júl', 'aug', 'szep', 'okt', 'nov', 'dec'],
    today: 'Ma',
    clear: 'Töröl'
  });

  // employees assign
  const [employeesSource, setEmployeesSource] = useState([]);
  const [employeesToAdd, setEmployeesToAdd] = useState([]);

  const [loadingEmployeesSource, setLoadingEmployeesSource] = useState(false);
  const [totalRecordsEmployeesSource, setTotalRecordsEmployeesSource] = useState(0);
  const [rowsEmployeesSource, setRowsEmployeesSource] = useState(10);
  const [lazyParamsEmployeesSource, setLazyParamsEmployeesSource] = useState({
    first: 0,
    rows: rowsEmployeesSource,
    page: 0,
    sortField: 'id',
    sortOrder: -1
  });
  let loadLazyTimeoutEmployeesSource = null;
  const loadLazyDataEmployeesSource = (worktypeId) => {
    setLoadingEmployeesSource(true);
    if (loadLazyTimeoutEmployeesSource) {
      clearTimeout(loadLazyTimeoutEmployeesSource);
    }
    loadLazyTimeoutEmployeesSource = setTimeout(() => {
      EmployeeListService(JSON.stringify(lazyParamsEmployeesSource))
        .then(response => {
          setTotalRecordsEmployeesSource(response.data.total_item_count);
          setEmployeesSource(response.data.items);
          setLoadingEmployeesSource(false);
        })
        .catch(error => {
          window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
        })
    }, Math.random() * 1000 + 250);
  }
  const onPageEmployeesSource = (event) => {
    let _lazyParams = {...lazyParamsEmployeesSource, ...event};
    setLazyParamsEmployeesSource(_lazyParams);
  }
  const onSortEmployeesSource = (event) => {
    let _lazyParams = {...lazyParamsEmployeesSource, ...event};
    setLazyParamsEmployeesSource(_lazyParams);
  }
  const onFilterEmployeesSource = (event) => {
    let _lazyParams = {...lazyParamsEmployeesSource, ...event};
    _lazyParams['first'] = 0;
    _lazyParams['page'] = 0;
    setLazyParamsEmployeesSource(_lazyParams);
  }
  const pagerEmployeesSource = {
    layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
    'RowsPerPageDropdown': (options) => {
      const dropdownOptions = [
        {label: Number(process.env.REACT_APP_LIST_ROW_OP1), value: Number(process.env.REACT_APP_LIST_ROW_OP1)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP2), value: Number(process.env.REACT_APP_LIST_ROW_OP2)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP3), value: Number(process.env.REACT_APP_LIST_ROW_OP3)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP4), value: Number(process.env.REACT_APP_LIST_ROW_OP4)},
      ];

      return (
        <>
          {/*<span className="p-mx-1" style={{color: 'var(--text-color)', userSelect: 'none'}}>Tételek egy oldalon: </span>*/}
          <Dropdown value={options.value} options={dropdownOptions}
                    onChange={(e) => setRowsEmployeesSource(e.target.value)}
                    appendTo={document.body}/>
        </>
      );
    },
    'CurrentPageReport': (options) => {
      return (
        <span style={{color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center'}}>
                        {options.first} - {options.last} / {options.totalRecords}
        </span>
      )
    }
  };

  useEffect(() => {
    console.log(props)
    loadLazyDataEmployeesSource();
  }, [lazyParamsEmployeesSource])

  return (
    <>
      <Panel>
        <Form onSubmit={onSubmit} initialValues={formData}
              validate={validate} render={({handleSubmit, submitting}) => (
          <form onSubmit={handleSubmit} className="">
            <div className={"p-grid"}>
              <div className={"p-col-12 p-lg-12 p-xl-12"}>
                <div className={"p-grid"}>
                  <div className={"p-col-12"}>
                    <h3>
                      <i className={"pi pi-list"}></i> Alapadatok
                    </h3>
                  </div>
                </div>
                <div className={"p-grid"}>
                  <div className={"p-col-12 p-lg-3"}>
                    <Field name="date_from" render={({input, meta}) => (
                      <div className="p-field p-fluid">
                        <label htmlFor="date_from"
                               className={classNames({'p-error': isFormFieldValid(meta)})}>Dátumtól</label>
                        <span className="">
                          <div className="p-inputgroup calendar-icon-only">
                            <InputMask id={"date_from"}
                                       mask={"9999-99-99"}
                                       placeholder={"ÉÉÉÉ-HH-NN"}
                                       value={formData.date_from}
                                       onChange={(e) => {
                                         if (e.value.indexOf("_") === -1) {
                                           if (e.value === '') {
                                             e.value = null
                                           }
                                           setFormData({
                                             ...formData,
                                             date_from: e.value
                                           })
                                         }
                                       }}
                            />
                            <Calendar value={formData.date_from}
                                      locale="hu"
                                      format={'yy-mm-dd'}
                                      showIcon
                                      onChange={(e) => {
                                        setFormData({
                                          ...formData,
                                          date_from: moment.utc(e.value).local().format('YYYY-MM-DD')
                                        })
                                      }}/>
                          </div>
                    </span>
                        {getFormErrorMessage(meta)}
                      </div>
                    )}/>
                  </div>
                  <div className={"p-col-12 p-lg-3"}>
                    <Field name="date_to" render={({input, meta}) => (
                      <div className="p-field p-fluid">
                        <label htmlFor="date_to"
                               className={classNames({'p-error': isFormFieldValid(meta)})}>Dátumig</label>
                        <span className="">
                          <div className="p-inputgroup calendar-icon-only">
                          <InputMask id={"date_to"}
                                     mask={"9999-99-99"}
                                     placeholder={"ÉÉÉÉ-HH-NN"}
                                     value={formData.date_to}
                                     onChange={(e) => {
                                       if (e.value.indexOf("_") === -1) {
                                         if (e.value === '') {
                                           e.value = null
                                         }
                                         setFormData({
                                           ...formData,
                                           date_to: e.value
                                         })
                                       }
                                     }}
                          />
                            <Calendar value={formData.date_to}
                                      locale="hu"
                                      format={'yy-mm-dd'}
                                      showIcon
                                      onChange={(e) => {
                                        setFormData({
                                          ...formData,
                                          date_to: moment.utc(e.value).local().format('YYYY-MM-DD')
                                        })
                                      }}/>
                          </div>
                    </span>
                        {getFormErrorMessage(meta)}
                      </div>
                    )}/>
                  </div>
                  <div className={"p-col-12 p-lg-3"}>
                    <Field name="time_from" render={({input, meta}) => (
                      <div className="p-field p-fluid">
                        <label htmlFor="time_from"
                               className={classNames({'p-error': isFormFieldValid(meta)})}>Időponttól</label>
                        <span className={"p-d-block"}>
                          <InputMask id={"time_from"}
                                     mask={"99:99"}
                                     placeholder={"OO:PP"}
                                     value={formData.time_from}
                                     onChange={(e) => {
                                       if (e.value.indexOf("_") === -1) {
                                         if (e.value === '') {
                                           e.value = null
                                         }
                                         setFormData({
                                           ...formData,
                                           time_from: e.value
                                         })
                                       }
                                     }}
                          />
                    </span>
                        {getFormErrorMessage(meta)}
                      </div>
                    )}/>
                  </div>
                  <div className={"p-col-12 p-lg-3"}>
                    <Field name="time_to" render={({input, meta}) => (
                      <div className="p-field p-fluid">
                        <label htmlFor="time_to"
                               className={classNames({'p-error': isFormFieldValid(meta)})}>Időpontig</label>
                        <span className={"p-d-block"}>
                          <InputMask id={"time_to"}
                                     mask={"99:99"}
                                     placeholder={"OO:PP"}
                                     value={formData.time_to}
                                     onChange={(e) => {
                                       if (e.value.indexOf("_") === -1) {
                                         if (e.value === '') {
                                           e.value = null
                                         }
                                         setFormData({
                                           ...formData,
                                           time_to: e.value
                                         })
                                       }
                                     }}
                          />
                    </span>
                        {getFormErrorMessage(meta)}
                      </div>
                    )}/>
                  </div>
                  <div className={"p-col-12 p-lg-3"}>
                    <Field name="break_minutes" render={({input, meta}) => (
                      <div className="p-field p-fluid">
                        <label htmlFor="break_minutes"
                               className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldBreakMinutes')}</label>
                        <span className="p-d-block">
                          <InputNumber id="break_minutes" {...input}
                                       min={0}
                                       minFractionDigits={0}
                                       maxFractionDigits={0}
                                       locale="hu-HU"
                                       onValueChange={(e) => {
                                         setFormData({
                                           ...formData,
                                           break_minutes: e.value ?? 0
                                         })
                                       }}
                                       value={formData.break_minutes ?? 0}
                                       className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                        </span>
                        {getFormErrorMessage(meta)}
                      </div>
                    )}/>
                  </div>
                </div>
              </div>
              {props?.initialValues?.type === 'EMPLOYEE_CAPACITY' ? (
                  <>
                    <div className={"p-col-12 p-lg-12 p-xl-12"}>
                      <div className={"p-grid"}>
                        <div className={"p-col-12"}>
                          <h3 className={"p-mt-0 p-pt-0"}>
                            <i className={"pi pi-list"}></i> Kiválasztható munkavállalók
                          </h3>
                        </div>
                      </div>
                      <DataTable size={localStorage.getItem('scale')}
                                 emptyMessage="Nincs találat."
                                 value={employeesSource} paginator first={lazyParamsEmployeesSource.first}
                                 totalRecords={totalRecordsEmployeesSource} onPage={onPageEmployeesSource}
                                 onSort={onSortEmployeesSource} sortField={lazyParamsEmployeesSource.sortField}
                                 sortOrder={lazyParamsEmployeesSource.sortOrder}
                                 onFilter={onFilterEmployeesSource} filters={lazyParamsEmployeesSource.filters}
                                 loading={loadingEmployeesSource} lazy
                                 paginatorTemplate={pagerEmployeesSource} rows={rowsEmployeesSource}
                                 autoLayout={true}
                                 selection={employeesToAdd}
                                 onSelectionChange={e => {
                                   setEmployeesToAdd(e.value)
                                 }}
                                 dataKey="id"
                                 filterDisplay="row"
                                 responsiveLayout="scroll"
                                 stripedRows
                                 selectionMode="checkbox"
                      >
                        <Column selectionMode="multiple" headerStyle={{width: '3em'}}></Column>
                        <Column field="name" header="Név" sortable filter filterPlaceholder="Név"></Column>
                      </DataTable>
                    </div>
                  </>
              ):(
                <>
                  <div className={"p-col-12 p-lg-12 p-xl-12"}>
                    <div className={"p-grid"}>
                      <div className={"p-col-12"}>
                        <h3 className={"p-mt-0 p-pt-0"}>
                          <i className={"pi pi-list"}></i> Ciklusok száma
                        </h3>
                      </div>
                    </div>
                    <div className={"p-col-12 p-lg-6"}>
                      <Field name="count" render={({input, meta}) => (
                        <div className="p-field p-fluid">
                          <label htmlFor="count"
                                 className={classNames({'p-error': isFormFieldValid(meta)})}>Mennyiség</label>
                          <span className="p-d-block">
                              <InputNumber id="count" {...input}
                                           minFractionDigits={0}
                                           maxFractionDigits={9}
                                           locale="hu-HU"
                                           onValueChange={(e) => {
                                             setFormData({
                                               ...formData,
                                               count: e.value
                                             })
                                           }}
                                           value={formData.count}
                                           className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                            </span>
                          {getFormErrorMessage(meta)}
                        </div>
                      )}/>
                    </div>


                  </div>
                </>
              )}

            </div>
            <div className={"p-grid p-mt-1"}>
              <div className={"p-col-12 p-lg-6 p-xl-6"}>

              </div>
              <div className={"p-col-12 p-lg-6 p-xl-6 p-text-right"}>
                <Button type="submit" label="Mentés" icon={"pi pi-check"} loading={loading}
                        className="p-button-success"/>
              </div>
            </div>
          </form>
        )}/>
      </Panel>
    </>
  )
}
export default withTranslation('common')(ScheduleFormComponent);
